import { render, staticRenderFns } from "./OrderItemList.vue?vue&type=template&id=2580ccc0&scoped=true"
import script from "./OrderItemList.vue?vue&type=script&lang=js"
export * from "./OrderItemList.vue?vue&type=script&lang=js"
import style0 from "./OrderItemList.vue?vue&type=style&index=0&id=2580ccc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580ccc0",
  null
  
)

export default component.exports